import { render, staticRenderFns } from "./creditcard-installment.vue?vue&type=template&id=708d7fd9"
import script from "./creditcard-installment.vue?vue&type=script&lang=js"
export * from "./creditcard-installment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports